// extracted by mini-css-extract-plugin
export default {"banner":"index-module--banner--dsB2+","banner2":"index-module--banner2--07IFX","banner3":"index-module--banner3--HKEkL","banner4":"index-module--banner4--ReTx+"};